import { jsx as _jsx } from "react/jsx-runtime";
import { usePagination } from '@material-ui/lab/Pagination';
import { PaginationItemWrapper, PaginationWrapper } from './styles';
import { PaginationItem } from './PaginationItem';
export var PaginationBase = function (_a) {
    var onPageChange = _a.onPageChange, pageCount = _a.pageCount, selectedPage = _a.selectedPage;
    var paginationDataList = usePagination({
        page: selectedPage,
        count: pageCount,
    }).items;
    return (_jsx(PaginationWrapper, { children: paginationDataList &&
            paginationDataList.map(function (paginationData, index) {
                return (_jsx(PaginationItemWrapper, { children: _jsx(PaginationItem, { paginationData: paginationData, onPageChange: onPageChange, selectedPage: selectedPage }) }, index));
            }) }));
};
